import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import AddIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
//Limitless imports
import { log as pilog } from "@limitless/common/utils/Logging";
import HeaderIconButton from "../buttons/header-icon-button/HeaderIconButton";
const INITIAL_STATE = {
  areAnySelected: false,
  allSelected: false,
  deletionList: {}
};
const getInitialState = (selectedList, labelFormatter) => {
  return getSelectedForDeletionState(selectedList, {}, labelFormatter);
};
const getSelectedForDeletionState = (selectedList, currentSelectedList, labelFormatter) => {
  const selected = INITIAL_STATE;
  selectedList.map(item => {
    const label = labelFormatter ? labelFormatter(item) : item;
    if (currentSelectedList[label]) {
      selected.deletionList[label] = currentSelectedList[label];
      if (selected.deletionList[label].checked === true) {
        selected.areAnySelected = true;
      }
    } else {
      selected.deletionList[label] = {};
      selected.deletionList[label].item = item;
      selected.deletionList[label].checked = false;
    }
  });
  return selected;
};
const AddRemove = ({
  classes,
  availableTitle,
  selectedTitle,
  availableList,
  selectedList,
  minHeight,
  onValueChange,
  labelFormatter,
  showCount
}) => {
  const [containerWidth, setContainerWidth] = React.useState("");
  const log = pilog.getLogger("AddRemove");
  const [selected, setSelected] = React.useState(getInitialState(selectedList, labelFormatter));
  const {
    deletionList,
    areAnySelected,
    allSelected
  } = selected;
  log.debug(selected);
  const selectorContainerRef = React.useRef(null);
  //in order to have correct width sticky headers we have to do this little ref dance
  React.useEffect(() => {
    setContainerWidth(`${selectorContainerRef.current.offsetWidth - 11}px`);
  }, [selectorContainerRef]);
  React.useEffect(() => {
    log.debug("effecting");
    if (selectedList.length !== deletionList) {
      setSelected(getSelectedForDeletionState(selectedList, deletionList, labelFormatter));
    }
  }, [selectedList]);
  const handleAddAll = () => {
    onValueChange([], availableList.concat(selectedList));
  };
  const handleAddItem = (label, item) => {
    const newAvailableList = availableList.filter(availableItem => {
      const availableLabel = labelFormatter ? labelFormatter(availableItem) : availableItem;
      return availableLabel !== label;
    });
    log.debug("add item ", newAvailableList);
    onValueChange(newAvailableList, selectedList.concat([item]));
    setSelected(getInitialState(selectedList, labelFormatter));
  };
  const handleDeleteItem = () => {
    if (allSelected) {
      onValueChange(availableList.concat(selectedList), []);
    } else {
      const newSelectedList = [];
      const newAvailableList = [];
      selectedList.map(selectedItem => {
        const selectedLabel = labelFormatter ? labelFormatter(selectedItem) : selectedItem;
        if (deletionList[selectedLabel].checked === true) {
          newAvailableList.push(selectedItem);
        } else {
          newSelectedList.push(selectedItem);
        }
      });
      onValueChange(availableList.concat(newAvailableList), newSelectedList);
    }
    setSelected(getInitialState(selectedList, labelFormatter));
  };
  const handleSelectAllForDelete = () => {
    if (allSelected) {
      setSelected(getInitialState(selectedList, labelFormatter));
    } else {
      const selected = {};
      selectedList.map(item => {
        const label = labelFormatter ? labelFormatter(item) : item;
        selected[label] = {
          checked: true,
          item
        };
      });
      setSelected({
        deletionList: selected,
        allSelected: true,
        areAnySelected: true
      });
    }
  };
  const handleSelectedItemCheck = label => {
    const newSelectedForDeletion = {
      ...deletionList
    };
    newSelectedForDeletion[label].checked = !newSelectedForDeletion[label].checked;
    let newAreAnySelected = false;
    Object.keys(newSelectedForDeletion).map(itemKey => {
      const item = newSelectedForDeletion[itemKey];
      if (item.checked === true) {
        newAreAnySelected = true;
      }
    });
    setSelected({
      deletionList: newSelectedForDeletion,
      allSelected: false,
      areAnySelected: newAreAnySelected
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.addRemoveContainer,
    style: {
      minHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.horizontalLine
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.selectorContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.availableContainer,
    ref: selectorContainerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.row} ${classes.stickyRow}`,
    style: {
      width: containerWidth || "unset"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.heading
  }, availableTitle, " ", showCount && `(${availableList === null || availableList === void 0 ? void 0 : availableList.length})`), /*#__PURE__*/React.createElement(HeaderIconButton, {
    buttonId: "addAllButton",
    onButtonClick: handleAddAll,
    tooltip: "Add All",
    icon: /*#__PURE__*/React.createElement(AddIcon, {
      className: classes.icon
    }),
    disabled: availableList.length === 0,
    color: "secondary"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.listContainer
  }, availableList.map((item, index) => {
    const label = labelFormatter ? labelFormatter(item) : item;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.row,
      key: index,
      style: {
        width: containerWidth || "unset"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, label), /*#__PURE__*/React.createElement(HeaderIconButton, {
      buttonId: `addItem${index}`,
      onButtonClick: () => handleAddItem(label, item),
      tooltip: "Add item",
      icon: /*#__PURE__*/React.createElement(AddIcon, {
        className: classes.icon
      }),
      color: "secondary"
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.verticalLine
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.selectedContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.row} ${classes.stickyRow}`,
    style: {
      width: containerWidth || "unset"
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    classes: {
      label: classes.heading
    },
    control: /*#__PURE__*/React.createElement(Checkbox, {
      id: "selectAllCheckBox",
      value: "",
      checked: allSelected,
      onChange: handleSelectAllForDelete,
      checkedIcon: /*#__PURE__*/React.createElement(CheckBoxIcon, {
        color: "secondary",
        className: classes.checkboxIconSize
      }),
      icon: /*#__PURE__*/React.createElement(CheckBoxOutlineBlankIcon, {
        color: "secondary",
        className: classes.checkboxIconSize
      }),
      disabled: selectedList.length === 0
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      className: classes.heading
    }, selectedTitle)
  }), /*#__PURE__*/React.createElement(HeaderIconButton, {
    buttonId: "removeAllButton",
    onButtonClick: handleDeleteItem,
    tooltip: "Delete Selected Items",
    icon: /*#__PURE__*/React.createElement(DeleteIcon, {
      className: classes.icon
    }),
    disabled: selectedList.length === 0 || !areAnySelected,
    color: "secondary"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.listContainer
  }, selectedList.map((item, index) => {
    const label = labelFormatter ? labelFormatter(item) : item;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.row,
      key: index
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        id: `addItem${index}`,
        value: "",
        checked: deletionList[label].checked,
        onChange: () => handleSelectedItemCheck(label),
        checkedIcon: /*#__PURE__*/React.createElement(CheckBoxIcon, {
          color: "secondary",
          className: classes.checkboxIconSize
        }),
        icon: /*#__PURE__*/React.createElement(CheckBoxOutlineBlankIcon, {
          color: "secondary",
          className: classes.checkboxIconSize
        })
      }),
      label: /*#__PURE__*/React.createElement(Typography, null, label)
    }));
  })))));
};
const styles = theme => ({
  addRemoveContainer: {
    display: "flex",
    flex: 1,
    marginTop: 32,
    flexDirection: "column"
  },
  heading: {
    color: theme.palette.contrast.text,
    fontSize: 12,
    fontWeight: 700
  },
  horizontalLine: {
    width: "100%",
    height: 3,
    backgroundColor: "rgba(0,0,0,0.2)",
    borderRadius: 10,
    marginBottom: 16
  },
  selectorContainer: {
    display: "flex",
    flex: 1,
    maxHeight: 300,
    overflowY: "auto",
    overflowX: "hidden"
  },
  availableContainer: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: theme.palette.border,
    paddingLeft: 11
  },
  verticalLine: {
    width: 3,
    backgroundColor: "rgba(0,0,0,0.2)",
    borderRadius: 10,
    marginLeft: 24,
    marginRight: 24,
    position: "sticky",
    top: 0
  },
  selectedContainer: {
    width: "50%",
    display: "flex",
    position: "relative",
    flexDirection: "column"
  },
  stickyRow: {
    position: "absolute",
    top: 0,
    backgroundColor: theme.background.paper,
    zIndex: 1000
  },
  listContainer: {
    marginTop: 50
  },
  icon: {
    fontSize: 26
  }
});
export default withStyles(styles)(AddRemove);
AddRemove.propTypes = {
  classes: PropTypes.object.isRequired,
  availableTitle: PropTypes.string.isRequired,
  selectedTitle: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  availableList: PropTypes.array.isRequired,
  selectedList: PropTypes.array.isRequired,
  minHeight: PropTypes.number.isRequired,
  labelFormatter: PropTypes.func,
  showCount: PropTypes.bool
};
AddRemove.defaultProps = {
  minHeight: 240,
  showCount: false
};